import {
  CHANGE_PAGE,
  CHANGE_PROJ,
  CHANGE_CARD,
  CHANGE_ITEM,
  DISPLAY_FOOTER,
  // CHANGE_LAN,
} from "./types";

export const changePage = (pageTitle) => (dispatch, getState) => {
  console.log("changePAge", pageTitle);
  dispatch({
    type: CHANGE_PAGE,
    payload: pageTitle,
  });
};

export const changeProject = (info) => (dispatch, getState) => {
  console.log("changeProject", info);
  dispatch({
    type: CHANGE_PROJ,
    payload: info,
  });
};

export const changeCard = (cardID) => (dispatch, getState) => {
  console.log("changeCard", cardID);
  dispatch({
    type: CHANGE_CARD,
    payload: cardID,
  });
};

export const changeItem = (info) => (dispatch, getState) => {
  console.log("changeCard", info);
  dispatch({
    type: CHANGE_ITEM,
    payload: info,
  });
};

export const displayFooter = (tf) => (dispatch, getState) => {
  console.log("displayFooter", tf);
  dispatch({
    type: DISPLAY_FOOTER,
    payload: tf,
  });
};

// export const changeLan = (lan) => (dispatch, getState) => {
//   console.log("changeLan", lan);
//   dispatch({
//     type: CHANGE_LAN,
//     payload: lan,
//   });
// };
